import Providers from "@/redux/provider/Provider";
import "@/styles/globals.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Head from "next/head";
import Layout from "@/components/Layout";
import { Fab } from "@mui/material";
import Image from "next/image";
import CookieConsentPopup from "@/components/Common/CookieConsentPopup";
import { usePathname } from "next/navigation";
import { RecaptchaProvider } from "@/contexts/RecaptchaContext";
import { useEffect } from "react";
import { trackPageViewed, getPageType } from "@/utils/gtmEvents";
import * as Sentry from "@sentry/nextjs";
// next/font must be imported in the app pipeline (here) for its @font-face +
// CSS-variable rules to be emitted. The variable class is applied to <body> in
// _document.js so those variables also cover MUI Dialog portals (outside #__next).
import "@/utils/fonts";

const COOKIE_CONSENT_POPUP = false;

export default function App({ Component, pageProps }) {
  const pathname = usePathname();

  // Track page views on route change
  useEffect(() => {
    if (pathname) {
      const pageUrl = typeof window !== "undefined" ? window.location.href : "";
      const pageType = getPageType(pathname);
      trackPageViewed(pageType, pageUrl);
    }
  }, [pathname]);

  // Capture unhandled promise rejections
  useEffect(() => {
    const handler = (event) => Sentry.captureException(event.reason);
    window.addEventListener("unhandledrejection", handler);
    return () => window.removeEventListener("unhandledrejection", handler);
  }, []);

  return (
    <>
      <Providers>
        <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
          <RecaptchaProvider>
            {/* <Header /> */}
            <Head>
              <link
                rel="icon"
                href="https://assets-global.website-files.com/6210bac66fc36f6399c235d0/623979f050eca63c3c28b363_favicon-bgremove.png"
              />
              {/* Google Fonts are now self-hosted via next/font (utils/fonts.js);
                  the render-blocking <link>/preconnect tags were removed for LCP. */}
            </Head>
            <Layout>
              <Component {...pageProps} />
              {COOKIE_CONSENT_POPUP && <CookieConsentPopup />}

              {pathname === "/blog-header" || pathname === "/blog-footer" ? (
                <></>
              ) : (
                <></>
                // <div className="fixed z-40 right-5 bottom-3">
                //   <a
                //     href="https://wa.me/9867099519?text=Hi%20Elchemy%20Team%2C%0AI%27m%20interested%20in%20following%20products%2C%20could%20you%20please%20help%3F%0AProduct%20Name%3A%0AQuantity%3A%0ADestination%3A%0AApplication%3A%0ALooking%20forward"
                //     target="_blank"
                //   >
                //     <Image
                //       src={getCDNImageUrl("whatsapp.svg")}
                //       width={55}
                //       height={55}
                //       alt="whatsapp icon"
                //     />
                //   </a>
                // </div>
              )}
            </Layout>
          </RecaptchaProvider>
        </Sentry.ErrorBoundary>
      </Providers>
    </>
  );
}
